(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8043],{

/***/ 34350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useAccountSupportAndContact; }
/* harmony export */ });
/* harmony import */ var _useLanguageDependentDataSsr_hook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18060);

var useAccountSupportAndContact = (0,_useLanguageDependentDataSsr_hook__WEBPACK_IMPORTED_MODULE_0__/* .useLanguageDependentDataSSr */ .Y)("account-support-and-contact");


/***/ }),

/***/ 7589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useRegisterPage; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_data_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4118);
/* harmony import */ var _utils_config_axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79098);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var useRegisterPage = (0,next_data_hooks__WEBPACK_IMPORTED_MODULE_1__/* .createDataHook */ .Qo)("authentification-form", function() {
    var _ref1 = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee1(param) {
        var locale, localeRes, result;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx1) {
            while(1)switch(_ctx1.prev = _ctx1.next){
                case 0:
                    locale = param.locale;
                    localeRes = !locale || locale === "catchAll" ? "en" : locale;
                    _ctx1.next = 4;
                    return (0,_utils_config_axios__WEBPACK_IMPORTED_MODULE_2__/* .backend */ .y)().get("api/strapi/authentification-form?_locale=".concat(localeRes));
                case 4:
                    result = _ctx1.sent.data;
                    _ctx1.next = 7;
                    return Promise.all(result.faqbox.map(function() {
                        var _ref2 = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(box) {
                            var ref;
                            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx2) {
                                while(1)switch(_ctx2.prev = _ctx2.next){
                                    case 0:
                                        ;
                                        _ctx2.next = 3;
                                        return Promise.all((ref = box.fa_qs) === null || ref === void 0 ? void 0 : ref.map(function() {
                                            var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(faqIdItem) {
                                                var id;
                                                return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                                    while(1)switch(_ctx.prev = _ctx.next){
                                                        case 0:
                                                            id = faqIdItem.id;
                                                            _ctx.next = 3;
                                                            return (0,_utils_config_axios__WEBPACK_IMPORTED_MODULE_2__/* .backend */ .y)().get("api/strapi/fa-qs/".concat(id));
                                                        case 3:
                                                            return _ctx.abrupt("return", _ctx.sent.data);
                                                        case 4:
                                                        case "end":
                                                            return _ctx.stop();
                                                    }
                                                }, _callee);
                                            }));
                                            return function(faqIdItem) {
                                                return _ref.apply(this, arguments);
                                            };
                                        }()));
                                    case 3:
                                        box.fa_qs = _ctx2.sent;
                                        return _ctx2.abrupt("return", box);
                                    case 5:
                                    case "end":
                                        return _ctx2.stop();
                                }
                            }, _callee2);
                        }));
                        return function(box) {
                            return _ref2.apply(this, arguments);
                        };
                    }()));
                case 7:
                    result.faqbox = _ctx1.sent;
                    return _ctx1.abrupt("return", result);
                case 9:
                case "end":
                    return _ctx1.stop();
            }
        }, _callee1);
    }));
    return function(_) {
        return _ref1.apply(this, arguments);
    };
}());


/***/ }),

/***/ 25977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Checkbox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _error_error_message__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63879);
/* harmony import */ var _typography_typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28773);
/* harmony import */ var _checkbox_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38434);
/* harmony import */ var _checkbox_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_checkbox_module_scss__WEBPACK_IMPORTED_MODULE_4__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var Checkbox = function(_param) {
    var name = _param.name, children = _param.children, register = _param.register, errorMessage = _param.errorMessage, inverted = _param.inverted, className = _param.className, inputProps = _objectWithoutProperties(_param, [
        "name",
        "children",
        "register",
        "errorMessage",
        "inverted",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        "data-testid": "checkbox",
        className: "".concat(className, " ").concat((_checkbox_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["checkbox-wrapper"]), " ").concat(inputProps.disabled ? (_checkbox_module_scss__WEBPACK_IMPORTED_MODULE_4___default().disabled) : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: (_checkbox_module_scss__WEBPACK_IMPORTED_MODULE_4___default().container),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({}, register(name), inputProps, {
                        type: "checkbox"
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        style: {
                            borderColor: inverted ? "#fff" : "#000"
                        },
                        className: (_checkbox_module_scss__WEBPACK_IMPORTED_MODULE_4___default().checkmark)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .Z, {
                        inverted: inverted,
                        children: children
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_error_error_message__WEBPACK_IMPORTED_MODULE_2__/* .ErrorMessage */ .B, {
                className: (_checkbox_module_scss__WEBPACK_IMPORTED_MODULE_4___default().error),
                children: errorMessage
            })
        ]
    });
};



/***/ }),

/***/ 71157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(95496);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_google_recaptcha_v3__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50259);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(87536);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25617);
/* harmony import */ var react_toast_notifications__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85611);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74231);
/* harmony import */ var _api_hooks_useAccountSupportAndContact__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34350);
/* harmony import */ var _api_hooks_useCurrentLanguage_hook__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91785);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37287);
/* harmony import */ var _utils_enums_toaster_types_enum__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18152);
/* harmony import */ var _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(77872);
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93217);
/* harmony import */ var _input_fields_input_input__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(17850);
/* harmony import */ var _input_fields_text_area_text_area__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(47085);
/* harmony import */ var _select_select__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(39382);
/* harmony import */ var _typography_typography__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(28773);
/* harmony import */ var _contact_form_module_scss__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(11965);
/* harmony import */ var _contact_form_module_scss__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_contact_form_module_scss__WEBPACK_IMPORTED_MODULE_18__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



















var ContactForm = function(props) {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var addToast = (0,react_toast_notifications__WEBPACK_IMPORTED_MODULE_4__/* .useToasts */ .e1)().addToast;
    var ref = (0,_redux__WEBPACK_IMPORTED_MODULE_8__/* .useAppSelector */ .CG)(function(state) {
        return {
            user: state.userSlice.user,
            supportModel: state.supportSlice.supportModel
        };
    }), user = ref.user, supportModel = ref.supportModel;
    var data = (0,_api_hooks_useAccountSupportAndContact__WEBPACK_IMPORTED_MODULE_6__/* .useAccountSupportAndContact */ .O)();
    var schema = yup__WEBPACK_IMPORTED_MODULE_5__/* .object */ .Ry({
        email: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required().email(),
        message: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required(),
        topic: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required()
    });
    var executeRecaptcha = (0,react_google_recaptcha_v3__WEBPACK_IMPORTED_MODULE_2__/* .useGoogleReCaptcha */ .xX)().executeRecaptcha;
    var language = (0,_api_hooks_useCurrentLanguage_hook__WEBPACK_IMPORTED_MODULE_7__/* .useCurrentLanguage */ .U)();
    var resolver = (0,_hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_16__/* .yupResolver */ .X)(schema);
    var ref1 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_17__/* .useForm */ .cI)({
        resolver: resolver,
        mode: "onChange"
    }), register = ref1.register, control = ref1.control, handleSubmit = ref1.handleSubmit, errors = ref1.formState.errors, reset = ref1.reset;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return function() {
            dispatch((0,_redux__WEBPACK_IMPORTED_MODULE_8__/* .removeSupportStatus */ .ww)());
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        reset({
            topic: "technicalProblem",
            email: user === null || user === void 0 ? void 0 : user.email
        });
    }, [
        data
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (data) {
            switch(supportModel.status){
                case 200:
                    addToast(data.mailSendSuccessfully, {
                        appearance: _utils_enums_toaster_types_enum__WEBPACK_IMPORTED_MODULE_9__/* .ToasterTypes.SUCCESS */ .p.SUCCESS
                    });
                    reset({
                        message: "",
                        topic: "technicalProblem"
                    });
                    break;
            }
        }
    }, [
        supportModel.status
    ]);
    var contactUser = function(form) {
        if (executeRecaptcha) {
            var token = executeRecaptcha("contact_page");
            token.then(function(res) {
                dispatch((0,_redux__WEBPACK_IMPORTED_MODULE_8__/* .sendContactForm */ .mM)(_objectSpread({}, form, {
                    language: language.toUpperCase(),
                    username: user ? user.username : "",
                    token: res
                })));
            });
        }
    };
    if (data) {
        var ref2, ref3, ref4, ref5, ref6, ref7;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_contact_form_module_scss__WEBPACK_IMPORTED_MODULE_18___default()["support-form-wrapper"]),
            "data-testid": "contact-form",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_15__/* .Typography */ .Z, {
                    element: "h3",
                    inverted: props.inverted,
                    variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_10__/* .TypographyVariantsEnum.HEADING4_BOLD */ .H.HEADING4_BOLD,
                    className: (_contact_form_module_scss__WEBPACK_IMPORTED_MODULE_18___default()["form-headline"]),
                    children: data.formHeadline
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_15__/* .Typography */ .Z, {
                    inverted: props.inverted,
                    children: data.formDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                    className: (_contact_form_module_scss__WEBPACK_IMPORTED_MODULE_18___default()["contact-form"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_contact_form_module_scss__WEBPACK_IMPORTED_MODULE_18___default()["contact-form-input-wrapper"]),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_contact_form_module_scss__WEBPACK_IMPORTED_MODULE_18___default()["left-inputs"]),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_select_select__WEBPACK_IMPORTED_MODULE_14__/* .Select */ .P, {
                                            className: (_contact_form_module_scss__WEBPACK_IMPORTED_MODULE_18___default().topic),
                                            placeholder: (ref2 = data.topic) === null || ref2 === void 0 ? void 0 : ref2.fieldPlaceholder,
                                            name: "topic",
                                            options: (ref3 = data.topic) === null || ref3 === void 0 ? void 0 : ref3.fieldSelectionOptions,
                                            control: control,
                                            label: (ref4 = data.topic) === null || ref4 === void 0 ? void 0 : ref4.fieldLabel,
                                            isSearchable: false,
                                            inverted: props.inverted,
                                            errorMessage: errors === null || errors === void 0 ? void 0 : (ref5 = errors["topic"]) === null || ref5 === void 0 ? void 0 : ref5.message
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_input_fields_input_input__WEBPACK_IMPORTED_MODULE_12__/* .Input */ .I, {
                                            name: "email",
                                            title: data.emailAddress,
                                            register: register,
                                            placeholder: data.placeholder,
                                            inverted: props.inverted,
                                            errorMessage: errors === null || errors === void 0 ? void 0 : (ref6 = errors["email"]) === null || ref6 === void 0 ? void 0 : ref6.message
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_input_fields_text_area_text_area__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                    name: "message",
                                    title: data.description,
                                    className: (_contact_form_module_scss__WEBPACK_IMPORTED_MODULE_18___default()["description-area"]),
                                    register: register,
                                    inverted: props.inverted,
                                    placeholder: data.placeholder,
                                    errorMessage: errors === null || errors === void 0 ? void 0 : (ref7 = errors["message"]) === null || ref7 === void 0 ? void 0 : ref7.message
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_contact_form_module_scss__WEBPACK_IMPORTED_MODULE_18___default()["button-wrapper"]),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_11__/* .Button */ .z, {
                                inverted: props.inverted,
                                onClick: handleSubmit(contactUser),
                                pending: supportModel.pending,
                                children: data.send
                            })
                        })
                    ]
                })
            ]
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactForm);
ContactForm.dataHooks = [
    _api_hooks_useAccountSupportAndContact__WEBPACK_IMPORTED_MODULE_6__/* .useAccountSupportAndContact */ .O
];


/***/ }),

/***/ 392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ ArticlePageTempHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/api/hooks/useLanguageDependentDataSsr.hook.ts
var useLanguageDependentDataSsr_hook = __webpack_require__(18060);
;// CONCATENATED MODULE: ./src/api/hooks/useTempHeader.hook.ts

var useTempHeader = (0,useLanguageDependentDataSsr_hook/* useLanguageDependentDataSSr */.Y)("temp-header");

// EXTERNAL MODULE: ./src/utils/_enums/button-variants.enum.tsx
var button_variants_enum = __webpack_require__(92212);
// EXTERNAL MODULE: ./src/utils/_enums/DefaultHeaderMobileLoginFormContext.enum.ts
var DefaultHeaderMobileLoginFormContext_enum = __webpack_require__(64889);
;// CONCATENATED MODULE: ./src/components/article-page/article-page-temp-header/article-page-temp-context/article-page-temp-context.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var initialData = {
    mobileNavOpen: false,
    dispatch: function() {
        alert("Error");
        return;
    }
};
var reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialData, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case DefaultHeaderMobileLoginFormContext_enum/* DefaultHeaderMobileLoginFormContextEnum.TOGGLEMOBILENAVIGATION */.E.TOGGLEMOBILENAVIGATION:
            {
                return _objectSpread({}, state, {
                    mobileNavOpen: !state.mobileNavOpen
                });
            }
        case DefaultHeaderMobileLoginFormContext_enum/* DefaultHeaderMobileLoginFormContextEnum.RESET */.E.RESET:
            {
                state.mobileNavOpen = false;
                return _objectSpread({}, state, {
                    mobileNavOpen: false
                });
            }
        default:
            return state;
    }
};
var ArticlePageTempHeaderContext = /*#__PURE__*/ react.createContext(initialData);
var ArticlePageTempHeaderContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react.useReducer)(reducer, initialData), state = ref[0], dispatch = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlePageTempHeaderContext.Provider, {
        value: _objectSpread({}, state, {
            dispatch: dispatch
        }),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/utils/_hooks/useArticlePageTempHeaderContext.hook.ts


var useArticlePageTempHeaderContext = function() {
    return (0,react.useContext)(ArticlePageTempHeaderContext);
};

// EXTERNAL MODULE: ./src/utils/_hooks/useBreakpoints.hook.ts
var useBreakpoints_hook = __webpack_require__(93890);
// EXTERNAL MODULE: ./src/components/_shared/header/header.tsx + 2 modules
var header = __webpack_require__(83086);
// EXTERNAL MODULE: ./src/components/_shared/header/header-background/header-background.tsx
var header_background = __webpack_require__(67822);
// EXTERNAL MODULE: ./src/components/_shared/header/header-mobile/header-mobile-navigation/header-mobile-navigation.tsx + 1 modules
var header_mobile_navigation = __webpack_require__(49229);
// EXTERNAL MODULE: ./src/components/article-page/article-page-temp-header/article-page-mobile-navigation/article-page-mobile-navigation.module.scss
var article_page_mobile_navigation_module = __webpack_require__(88461);
var article_page_mobile_navigation_module_default = /*#__PURE__*/__webpack_require__.n(article_page_mobile_navigation_module);
;// CONCATENATED MODULE: ./src/components/article-page/article-page-temp-header/article-page-mobile-navigation/article-page-mobile-navigation.tsx







var ArticlePageTempHeaderMobileNavigation = function(props) {
    var ref = useArticlePageTempHeaderContext(), mobileNavOpen = ref.mobileNavOpen, dispatch = ref.dispatch;
    var navLinks = useTempHeader().navLinks;
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(header_mobile_navigation/* HeaderMobileNavigation */.p, {
        className: (article_page_mobile_navigation_module_default())["default-header-mobile-navigation"],
        open: mobileNavOpen,
        localizations: props.localization,
        forStaticPage: props.forStaticPage,
        pageType: props.pageType,
        onCancelClick: function() {
            return dispatch({
                type: DefaultHeaderMobileLoginFormContext_enum/* DefaultHeaderMobileLoginFormContextEnum.TOGGLEMOBILENAVIGATION */.E.TOGGLEMOBILENAVIGATION
            });
        },
        navLinks: (ref1 = navLinks === null || navLinks === void 0 ? void 0 : navLinks.map(function(param) {
            var external = param.external, label = param.label, link = param.link;
            return {
                label: label,
                value: link,
                external: external
            };
        })) !== null && ref1 !== void 0 ? ref1 : []
    });
};

// EXTERNAL MODULE: ./src/components/article-page/article-page-temp-header/article-page-temp-header.module.scss
var article_page_temp_header_module = __webpack_require__(79948);
var article_page_temp_header_module_default = /*#__PURE__*/__webpack_require__.n(article_page_temp_header_module);
;// CONCATENATED MODULE: ./src/components/article-page/article-page-temp-header/article-page-temp-header.tsx
function article_page_temp_header_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function article_page_temp_header_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            article_page_temp_header_defineProperty(target, key, source[key]);
        });
    }
    return target;
}













var ArticlePageTempHeaderComponent = function(param1) {
    var forStaticPage = param1.forStaticPage, availableLanguages = param1.availableLanguages, pageType = param1.pageType;
    var ref;
    var defaultHeaderData = useTempHeader();
    var dispatch = useArticlePageTempHeaderContext().dispatch;
    var value = (0,useBreakpoints_hook/* default */.Z)();
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: (article_page_temp_header_module_default())["article-page-temp-header"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_background/* HeaderBackground */.w, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* Header */.h, {
                        element: "div",
                        inverted: true,
                        forStaticPage: forStaticPage,
                        languages: availableLanguages,
                        pageType: pageType,
                        navLinks: (ref1 = defaultHeaderData === null || defaultHeaderData === void 0 ? void 0 : (ref = defaultHeaderData.navLinks) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                            var label = param.label, link = param.link, external = param.external;
                            return {
                                label: label,
                                value: link,
                                external: external
                            };
                        })) !== null && ref1 !== void 0 ? ref1 : [],
                        buttons: value === "mobile" ? [
                            {
                                variant: button_variants_enum/* ButtonVariantsEnum.SECONDARY_OUTLINED */.l.SECONDARY_OUTLINED,
                                icon: {
                                    element: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: [
                                            "far",
                                            "bars"
                                        ]
                                    }),
                                    align: "right"
                                },
                                onClick: function() {
                                    dispatch({
                                        type: DefaultHeaderMobileLoginFormContext_enum/* DefaultHeaderMobileLoginFormContextEnum.TOGGLEMOBILENAVIGATION */.E.TOGGLEMOBILENAVIGATION
                                    });
                                }
                            }
                        ] : undefined
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlePageTempHeaderMobileNavigation, {
                        localization: availableLanguages,
                        pageType: pageType,
                        forStaticPage: forStaticPage
                    })
                ]
            })
        ]
    });
};
var WithContext = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlePageTempHeaderContextProvider, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlePageTempHeaderComponent, article_page_temp_header_objectSpread({}, props))
    });
};
var ArticlePageTempHeader = WithContext;
WithContext.dataHooks = [
    useTempHeader
];
WithContext.defaultProps = {
    availableLanguages: []
};


/***/ }),

/***/ 17750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ RegisterFormLight; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(95496);
// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 2 modules
var lib_esm = __webpack_require__(35553);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./node_modules/react-toast-notifications/dist/index.js
var dist = __webpack_require__(85611);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/api/hooks/useGlobal.hook.ts
var useGlobal_hook = __webpack_require__(77459);
// EXTERNAL MODULE: ./src/api/hooks/useRegisterPage.hook.ts
var useRegisterPage_hook = __webpack_require__(7589);
// EXTERNAL MODULE: ./src/api/models/instance-status.tsx
var instance_status = __webpack_require__(23812);
// EXTERNAL MODULE: ./src/redux/index.tsx + 21 modules
var redux = __webpack_require__(37287);
// EXTERNAL MODULE: ./src/redux/actions/blockchain.action.tsx + 20 modules
var blockchain_action = __webpack_require__(39025);
// EXTERNAL MODULE: ./src/redux/slices/creatoken-slice.tsx + 3 modules
var creatoken_slice = __webpack_require__(99950);
// EXTERNAL MODULE: ./src/utils/_enums/basic-card-variants.enum.ts
var basic_card_variants_enum = __webpack_require__(90017);
// EXTERNAL MODULE: ./src/utils/_enums/image-content-type.enum.tsx
var image_content_type_enum = __webpack_require__(26884);
// EXTERNAL MODULE: ./src/utils/_enums/sales-type.tsx
var sales_type = __webpack_require__(9943);
// EXTERNAL MODULE: ./src/utils/_enums/toaster-types.enum.tsx
var toaster_types_enum = __webpack_require__(18152);
// EXTERNAL MODULE: ./src/utils/_helper/enum-to-language-mapper.tsx
var enum_to_language_mapper = __webpack_require__(15487);
// EXTERNAL MODULE: ./src/utils/_helper/strapi-mapper.tsx
var strapi_mapper = __webpack_require__(962);
// EXTERNAL MODULE: ./src/utils/_helper/truncate-string-helper.ts
var truncate_string_helper = __webpack_require__(18841);
// EXTERNAL MODULE: ./src/utils/_helper/valid-country-helper.tsx
var valid_country_helper = __webpack_require__(63720);
// EXTERNAL MODULE: ./src/components/_shared/basic-card/basic-card.tsx + 2 modules
var basic_card = __webpack_require__(40708);
// EXTERNAL MODULE: ./src/components/_shared/button/button.tsx
var button_button = __webpack_require__(93217);
// EXTERNAL MODULE: ./src/components/_shared/checkbox/checkbox.tsx
var checkbox_checkbox = __webpack_require__(25977);
// EXTERNAL MODULE: ./src/components/_shared/dialog/dialog.tsx + 2 modules
var dialog = __webpack_require__(72807);
// EXTERNAL MODULE: ./src/components/_shared/input-fields/input/input.tsx
var input = __webpack_require__(17850);
// EXTERNAL MODULE: ./src/api/hooks/useCardText.hook.ts
var useCardText_hook = __webpack_require__(14375);
// EXTERNAL MODULE: ./src/utils/_enums/typeography-variants.enum.tsx
var typeography_variants_enum = __webpack_require__(77872);
// EXTERNAL MODULE: ./src/components/_shared/teaser-card-components/teaser-card-footer/teaser-card-footer.tsx
var teaser_card_footer = __webpack_require__(67396);
// EXTERNAL MODULE: ./src/components/_shared/teaser-card-components/teaser-card-text/teaser-card-text.tsx
var teaser_card_text = __webpack_require__(33997);
// EXTERNAL MODULE: ./src/components/_shared/typography/typography.tsx
var typography = __webpack_require__(28773);
// EXTERNAL MODULE: ./src/components/_shared/instance-card/instance-card.module.scss
var instance_card_module = __webpack_require__(6762);
var instance_card_module_default = /*#__PURE__*/__webpack_require__.n(instance_card_module);
;// CONCATENATED MODULE: ./src/components/_shared/instance-card/instance-card.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var InstanceCard = function(props) {
    var data = (0,useCardText_hook/* useCardText */.G)();
    var ref, _serialNumber, _copies;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-testid": "instance-card",
        className: "".concat((instance_card_module_default())["instance-card-wrapper"], " ").concat((instance_card_module_default())["".concat(props.type ? props.type : "")]),
        children: [
            props.text.copies !== undefined && (props.text.serialNumber !== undefined || props.text.availableCopies !== undefined) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (instance_card_module_default())["optional-info"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                    variant: typeography_variants_enum/* TypographyVariantsEnum.TOPLINE_OR_LABEL */.H.TOPLINE_OR_LABEL,
                    inverted: props.inverted,
                    children: props.text.availableCopies !== undefined ? "".concat(props.text.availableCopies, " / ").concat(props.text.copies) : "".concat((ref = data === null || data === void 0 ? void 0 : data.copy) !== null && ref !== void 0 ? ref : "", " ").concat((_serialNumber = props.text.serialNumber) !== null && _serialNumber !== void 0 ? _serialNumber : "", " / ").concat((_copies = props.text.copies) !== null && _copies !== void 0 ? _copies : "")
                })
            }) : undefined,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (instance_card_module_default())["teaser-card-text"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_card_text/* default */.Z, _objectSpread({}, props.text, {
                    inverted: props.inverted,
                    variant: props.type,
                    redirectUrl: props.redirectUrl
                }))
            }),
            props.footer && /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_card_footer/* default */.Z, _objectSpread({}, props.footer, {
                inverted: props.inverted,
                type: props.type,
                redirectUrl: props.redirectUrl
            }))
        ]
    });
};
/* harmony default export */ var instance_card = (InstanceCard);

// EXTERNAL MODULE: ./src/components/_shared/link/link-base/link-base.tsx
var link_base = __webpack_require__(27397);
// EXTERNAL MODULE: ./src/components/_shared/media/media.tsx + 3 modules
var media = __webpack_require__(38925);
// EXTERNAL MODULE: ./src/components/_shared/select/select.tsx
var select_select = __webpack_require__(39382);
// EXTERNAL MODULE: ./src/components/_shared/spacer/spacer.tsx
var spacer = __webpack_require__(4363);
// EXTERNAL MODULE: ./src/components/_shared/teaser/teaser.tsx + 1 modules
var teaser = __webpack_require__(10725);
// EXTERNAL MODULE: ./src/components/_shared/text-section/text-section.tsx
var text_section = __webpack_require__(29209);
// EXTERNAL MODULE: ./src/components/register/register-form/register-form-light.module.scss
var register_form_light_module = __webpack_require__(64472);
var register_form_light_module_default = /*#__PURE__*/__webpack_require__.n(register_form_light_module);
;// CONCATENATED MODULE: ./src/components/register/register-form/register-form-light.tsx
function register_form_light_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function register_form_light_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            register_form_light_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




































var RegisterFormLight = function(props) {
    var ref43, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26;
    var registerPageData = (0,useRegisterPage_hook/* useRegisterPage */.Q)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var addToast = (0,dist/* useToasts */.e1)().addToast;
    var ref27 = (0,react.useState)(undefined), selectedVariant = ref27[0], setSelectedVariant = ref27[1];
    var ref28 = (0,react.useState)(), submittedData = ref28[0], setSubmittedData = ref28[1];
    var ref29 = (0,redux/* useAppSelector */.CG)(function(state) {
        return state.creatokenSlice;
    }), buyCreatokenModel = ref29.buyCreatokenModel, transactionHash = ref29.transactionHash, creatokenVariantsModel = ref29.creatokenVariantsModel;
    var ref30 = (0,redux/* useAppSelector */.CG)(function(state) {
        return state.blockchainSlice;
    }), walletId = ref30.walletId, isMetaMaskInstalled = ref30.isMetaMaskInstalled, chainId = ref30.chainId, pending = ref30.pending;
    var countryOptions = enum_to_language_mapper/* EnumToLanguageMapper.countriesMapping */.H.countriesMapping().filter(function(param) {
        var value = param.value;
        return (0,valid_country_helper/* isValidGeoIp */.g)(value.toLowerCase());
    });
    var data1 = (0,useGlobal_hook/* useGlobal */.O)();
    (0,react.useEffect)(function() {
        dispatch((0,creatoken_slice/* fetchCreatokenVariants */.Nl)());
    }, []);
    (0,react.useEffect)(function() {
        if (buyCreatokenModel.status && buyCreatokenModel.status !== 200) {
            dispatch((0,creatoken_slice/* resetBuyCreatokenState */.rc)());
        }
    }, [
        buyCreatokenModel.status
    ]);
    var ref31, ref32, ref33, ref34, ref35;
    var schema = yup_es/* object */.Ry({
        country: yup_es/* string */.Z_().required((ref31 = (ref43 = registerPageData === null || registerPageData === void 0 ? void 0 : registerPageData.country.fieldErrorMessages) === null || ref43 === void 0 ? void 0 : ref43.required) !== null && ref31 !== void 0 ? ref31 : ""),
        email: yup_es/* string */.Z_().required((ref32 = (ref1 = registerPageData === null || registerPageData === void 0 ? void 0 : registerPageData.email.fieldErrorMessages) === null || ref1 === void 0 ? void 0 : ref1.required) !== null && ref32 !== void 0 ? ref32 : "").email((ref33 = (ref2 = registerPageData === null || registerPageData === void 0 ? void 0 : registerPageData.email.fieldErrorMessages) === null || ref2 === void 0 ? void 0 : ref2.valid) !== null && ref33 !== void 0 ? ref33 : ""),
        agbConfirm: yup_es/* boolean */.O7().oneOf([
            true
        ], (ref34 = registerPageData === null || registerPageData === void 0 ? void 0 : (ref3 = registerPageData.agbAdvancedAccept) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fieldErrorMessages) === null || ref4 === void 0 ? void 0 : ref4.required) !== null && ref34 !== void 0 ? ref34 : ""),
        expirationRightOfWithdrawal: yup_es/* boolean */.O7().oneOf([
            true
        ], (ref35 = props === null || props === void 0 ? void 0 : props.expirationRightOfWithdrawalRequired) !== null && ref35 !== void 0 ? ref35 : "")
    });
    var resolver = (0,yup_module/* yupResolver */.X)(schema);
    var ref36 = (0,index_esm/* useForm */.cI)({
        resolver: resolver,
        mode: "onChange"
    }), register = ref36.register, handleSubmit = ref36.handleSubmit, control = ref36.control, _formState = ref36.formState, errors = _formState.errors, isSubmitted = _formState.isSubmitted;
    (0,react.useEffect)(function() {
        if (submittedData && walletId && selectedVariant && chainId) {
            if (chainId !== Number("1")) {
                addToast(props === null || props === void 0 ? void 0 : props.invalidEthereumNetwork, {
                    appearance: toaster_types_enum/* ToasterTypes.ERROR */.p.ERROR
                });
            } else {
                dispatch((0,creatoken_slice/* buyCreatoken */.jx)({
                    backendData: register_form_light_objectSpread({}, submittedData, {
                        variant: selectedVariant.tier,
                        wallet: walletId
                    }),
                    contractData: {
                        walletId: walletId,
                        price: lib_esm/* parseEther */.fi(selectedVariant.price.toString()).toString(),
                        tier: selectedVariant.tier
                    }
                }));
            }
            setSubmittedData(undefined);
        }
    }, [
        submittedData,
        walletId,
        chainId
    ]);
    var dataSubmitted = function(data) {
        setSubmittedData(data);
        dispatch((0,blockchain_action/* connectToMetaMask */._)());
    };
    var renderVariants = function() {
        if (creatokenVariantsModel.data && creatokenVariantsModel.data.length > 0) {
            var ref46, ref39, ref40, ref41;
            var ref42;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser/* default */.Z, {
                onLoadNewItems: function() {
                    return undefined;
                },
                maxCards: 6,
                headline: (ref46 = props.teaserHeadline) === null || ref46 === void 0 ? void 0 : ref46.headlineContent,
                headlineElement: (ref39 = props.teaserHeadline) === null || ref39 === void 0 ? void 0 : ref39.element,
                headlineVariant: (0,strapi_mapper/* mapStrapiHeadline */.z)((ref40 = props.teaserHeadline) === null || ref40 === void 0 ? void 0 : ref40.style),
                headlineStyle: (ref41 = props.teaserHeadline) === null || ref41 === void 0 ? void 0 : ref41.textAlign,
                withNumbers: false,
                errorMessage: !selectedVariant && isSubmitted ? props.noVariantSelectedMsg : "",
                type: basic_card_variants_enum/* BasicCardVariants.CREATOKEN_CARD */.I.CREATOKEN_CARD,
                pagination: {
                    page: 0,
                    size: 6
                },
                inverted: props.inverted,
                hideTeaserButtons: true,
                cards: creatokenVariantsModel.data.map(function(variant) {
                    var ref, ref44, ref45;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(basic_card/* default */.Z, {
                        inverted: props.inverted,
                        media: {
                            contentType: (ref = variant.coverArt) === null || ref === void 0 ? void 0 : ref.contentContentType,
                            mediaUrl: variant === null || variant === void 0 ? void 0 : (ref44 = variant.coverArt) === null || ref44 === void 0 ? void 0 : ref44.url,
                            posterUrl: variant.previewImage,
                            isTeaser: true
                        },
                        disabled: variant.purchasableInstances <= 0,
                        selected: variant.id === (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id),
                        onClick: function() {
                            var _tier;
                            setSelectedVariant({
                                id: variant.id,
                                price: variant.salesAttribute.price,
                                tier: (_tier = variant.tier) !== null && _tier !== void 0 ? _tier : -1,
                                coverArt: variant.coverArt
                            });
                        },
                        type: basic_card_variants_enum/* BasicCardVariants.CREATOKEN_CARD */.I.CREATOKEN_CARD,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(instance_card, {
                            text: {
                                headline: variant.title,
                                topline: (ref42 = data1 === null || data1 === void 0 ? void 0 : (ref45 = data1.brand) === null || ref45 === void 0 ? void 0 : ref45.creatokia) !== null && ref42 !== void 0 ? ref42 : "",
                                availableCopies: variant.purchasableInstances,
                                copies: variant.purchasableInstances + variant.instancesSold
                            },
                            inverted: props.inverted,
                            footer: {
                                purchasable: {
                                    ethPrice: variant.salesAttribute.price,
                                    ownerId: 1,
                                    status: instance_status/* InstanceStatus.ALL */.O.ALL
                                },
                                salesType: sales_type/* SalesType.FIXED_PRICE */.r.FIXED_PRICE
                            },
                            type: basic_card_variants_enum/* BasicCardVariants.CREATOKEN_CARD */.I.CREATOKEN_CARD
                        })
                    }, variant.id);
                })
            });
        }
    };
    var ref37, ref38;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                noValidate: true,
                className: "".concat((register_form_light_module_default())["authentification-form"], " ").concat((props === null || props === void 0 ? void 0 : props.inverted) ? (register_form_light_module_default()).inverted : ""),
                onSubmit: handleSubmit(dataSubmitted),
                children: [
                    renderVariants(),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (props === null || props === void 0 ? void 0 : props.teaserHeadlineAndParagraphHeadline) && (props === null || props === void 0 ? void 0 : props.teaserHeadlineAndParagraphParagraph) ? (register_form_light_module_default()).wrapper : "",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: (props === null || props === void 0 ? void 0 : props.teaserHeadlineAndParagraphHeadline) && (props === null || props === void 0 ? void 0 : props.teaserHeadlineAndParagraphParagraph) ? {
                                    flex: "1"
                                } : undefined,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                                        register: register,
                                        title: registerPageData === null || registerPageData === void 0 ? void 0 : (ref5 = registerPageData.email) === null || ref5 === void 0 ? void 0 : ref5.fieldLabel,
                                        type: "email",
                                        name: "email",
                                        placeholder: registerPageData === null || registerPageData === void 0 ? void 0 : (ref6 = registerPageData.email) === null || ref6 === void 0 ? void 0 : ref6.fieldHint,
                                        errorMessage: (ref7 = errors) === null || ref7 === void 0 ? void 0 : (ref8 = ref7["email"]) === null || ref8 === void 0 ? void 0 : ref8.message
                                    }, "email-input"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                                        height: "20px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(select_select/* Select */.P, {
                                        inverted: props === null || props === void 0 ? void 0 : props.inverted,
                                        control: control,
                                        label: registerPageData === null || registerPageData === void 0 ? void 0 : (ref9 = registerPageData.country) === null || ref9 === void 0 ? void 0 : ref9.fieldLabel,
                                        name: "country",
                                        placeholder: registerPageData === null || registerPageData === void 0 ? void 0 : (ref10 = registerPageData.country) === null || ref10 === void 0 ? void 0 : ref10.fieldHint,
                                        errorMessage: (ref11 = errors) === null || ref11 === void 0 ? void 0 : (ref12 = ref11["country"]) === null || ref12 === void 0 ? void 0 : ref12.message,
                                        options: countryOptions
                                    }, "country-input"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                                        height: "20px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox/* Checkbox */.X, {
                                        register: register,
                                        name: "agbConfirm",
                                        errorMessage: (ref13 = errors) === null || ref13 === void 0 ? void 0 : (ref14 = ref13["agbConfirm"]) === null || ref14 === void 0 ? void 0 : ref14.message,
                                        inverted: props.inverted,
                                        children: registerPageData === null || registerPageData === void 0 ? void 0 : (ref15 = registerPageData.agbAdvancedAccept) === null || ref15 === void 0 ? void 0 : ref15.fieldLabel
                                    }, "agb-checkbox"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                                        height: "20px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox/* Checkbox */.X, {
                                        name: "expirationRightOfWithdrawal",
                                        errorMessage: (ref16 = errors) === null || ref16 === void 0 ? void 0 : (ref17 = ref16["expirationRightOfWithdrawal"]) === null || ref17 === void 0 ? void 0 : ref17.message,
                                        register: register,
                                        inverted: props.inverted,
                                        children: props === null || props === void 0 ? void 0 : props.expirationRightOfWithdrawal
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                                        height: "20px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox/* Checkbox */.X, {
                                        register: register,
                                        name: "newsletter",
                                        inverted: props.inverted,
                                        children: registerPageData === null || registerPageData === void 0 ? void 0 : (ref18 = registerPageData.newsletterAccept) === null || ref18 === void 0 ? void 0 : ref18.fieldLabel
                                    }, "newsletter-checkbox"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                                        height: "20px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                        inverted: props === null || props === void 0 ? void 0 : props.inverted,
                                        disabled: !isMetaMaskInstalled,
                                        pending: pending || buyCreatokenModel.pending,
                                        children: props.buyButton
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                                        height: "30px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                        inverted: props === null || props === void 0 ? void 0 : props.inverted,
                                        children: isMetaMaskInstalled ? "" : props === null || props === void 0 ? void 0 : (ref19 = props.metaMaskNotInstalled) === null || ref19 === void 0 ? void 0 : ref19.content
                                    })
                                ]
                            }),
                            (props === null || props === void 0 ? void 0 : props.teaserHeadlineAndParagraphHeadline) && (props === null || props === void 0 ? void 0 : props.teaserHeadlineAndParagraphParagraph) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                                        width: "100px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (register_form_light_module_default())["legal-wrapper"],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                                className: (props === null || props === void 0 ? void 0 : props.inverted) ? (register_form_light_module_default())["white-text"] : undefined,
                                                disableMarkdown: true,
                                                variant: (0,strapi_mapper/* mapStrapiHeadline */.z)(props === null || props === void 0 ? void 0 : (ref20 = props.teaserHeadlineAndParagraphHeadline) === null || ref20 === void 0 ? void 0 : ref20.style),
                                                children: (ref37 = props === null || props === void 0 ? void 0 : (ref21 = props.teaserHeadlineAndParagraphHeadline) === null || ref21 === void 0 ? void 0 : ref21.headlineContent) !== null && ref37 !== void 0 ? ref37 : ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                                                height: "10px"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                                className: (props === null || props === void 0 ? void 0 : props.inverted) ? (register_form_light_module_default())["grey-text"] : undefined,
                                                children: (ref38 = props === null || props === void 0 ? void 0 : (ref22 = props.teaserHeadlineAndParagraphParagraph) === null || ref22 === void 0 ? void 0 : ref22.content) !== null && ref38 !== void 0 ? ref38 : ""
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            transactionHash && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* default */.Z, {
                onClose: function() {
                    return dispatch((0,creatoken_slice/* setTransactionHash */.rN)(undefined));
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(text_section/* default */.Z, {
                        title: props === null || props === void 0 ? void 0 : (ref23 = props.buyDialogHeadline) === null || ref23 === void 0 ? void 0 : ref23.headlineContent,
                        description: props === null || props === void 0 ? void 0 : (ref24 = props.buyDialogDescription) === null || ref24 === void 0 ? void 0 : ref24.content
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (register_form_light_module_default())["bottom-wrapper"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                                height: "20px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(media/* default */.ZP, {
                                alt: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref25 = selectedVariant.coverArt) === null || ref25 === void 0 ? void 0 : ref25.name,
                                src: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref26 = selectedVariant.coverArt) === null || ref26 === void 0 ? void 0 : ref26.url,
                                contentType: image_content_type_enum/* MediaContentType.MP4 */.L.MP4,
                                className: (register_form_light_module_default())["dialog-image"]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                                height: "20px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(link_base/* LinkBase */.w, {
                                href: "https://".concat(Number("1") === 5 ? "goerli." : "", "etherscan.io/tx/").concat(transactionHash),
                                external: true,
                                children: "https://".concat(Number("1") === 5 ? "goerli." : "", "etherscan.io/tx/").concat((0,truncate_string_helper/* default */.Z)(transactionHash, 6, 4))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
RegisterFormLight.dataHooks = [
    useRegisterPage_hook/* useRegisterPage */.Q
];


/***/ }),

/***/ 18841:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var truncateString = function(str, maxLettersBeforeTruncate, maxLettersAfterTruncate) {
    if (maxLettersBeforeTruncate + maxLettersAfterTruncate >= str.length) {
        return str;
    } else {
        return str.substring(0, maxLettersBeforeTruncate) + "..." + str.substring(str.length - maxLettersAfterTruncate);
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (truncateString);


/***/ }),

/***/ 38434:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","checkbox-wrapper":"checkbox_checkbox-wrapper__yTOgu","container":"checkbox_container__cO6DU","checkmark":"checkbox_checkmark__leBLq","disabled":"checkbox_disabled__AuzbX","error":"checkbox_error__TTIy1"};

/***/ }),

/***/ 11965:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","support-form-wrapper":"contact-form_support-form-wrapper__vbt8A","form-headline":"contact-form_form-headline__nu2zb","contact-form":"contact-form_contact-form__mtJlC","contact-form-input-wrapper":"contact-form_contact-form-input-wrapper__TM07f","left-inputs":"contact-form_left-inputs__m_1Fo","topic":"contact-form_topic__8DrfT","description-area":"contact-form_description-area__dRSeP","button-wrapper":"contact-form_button-wrapper__698sD"};

/***/ }),

/***/ 6762:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","instance-card-wrapper":"instance-card_instance-card-wrapper__C4BcL","teaser-card-text":"instance-card_teaser-card-text__C0LHw","optional-info":"instance-card_optional-info__FpIEm","basic-card-horizontal-small":"instance-card_basic-card-horizontal-small__bjbf9"};

/***/ }),

/***/ 88461:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"default-header-mobile-navigation":"article-page-mobile-navigation_default-header-mobile-navigation__wK_z3"};

/***/ }),

/***/ 79948:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","article-page-temp-header":"article-page-temp-header_article-page-temp-header__HmX7z"};

/***/ }),

/***/ 64472:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","authentification-form":"register-form-light_authentification-form__05o49","create-wallet-link":"register-form-light_create-wallet-link__WmteD","wrapper":"register-form-light_wrapper__tRvLM","legal-wrapper":"register-form-light_legal-wrapper__ZeWZH","bottom-wrapper":"register-form-light_bottom-wrapper__gdonD","dialog-image":"register-form-light_dialog-image__6ydey","inverted":"register-form-light_inverted__ZZDwO","white-text":"register-form-light_white-text__k0FVX","grey-text":"register-form-light_grey-text__P5jRg"};

/***/ }),

/***/ 86037:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(67294)) :
  0;
}(this, (function (exports, React) {
  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () {
              return e[k];
            }
          });
        }
      });
    }
    n['default'] = e;
    return n;
  }

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  var LEFT = "Left";
  var RIGHT = "Right";
  var UP = "Up";
  var DOWN = "Down";

  var defaultProps = {
    delta: 10,
    preventDefaultTouchmoveEvent: false,
    rotationAngle: 0,
    trackMouse: false,
    trackTouch: true
  };
  var initialState = {
    first: true,
    initial: [0, 0],
    start: 0,
    swiping: false,
    xy: [0, 0]
  };
  var mouseMove = "mousemove";
  var mouseUp = "mouseup";
  var touchEnd = "touchend";
  var touchMove = "touchmove";
  var touchStart = "touchstart";

  function getDirection(absX, absY, deltaX, deltaY) {
    if (absX > absY) {
      if (deltaX > 0) {
        return RIGHT;
      }

      return LEFT;
    } else if (deltaY > 0) {
      return DOWN;
    }

    return UP;
  }

  function rotateXYByAngle(pos, angle) {
    if (angle === 0) return pos;
    var angleInRadians = Math.PI / 180 * angle;
    var x = pos[0] * Math.cos(angleInRadians) + pos[1] * Math.sin(angleInRadians);
    var y = pos[1] * Math.cos(angleInRadians) - pos[0] * Math.sin(angleInRadians);
    return [x, y];
  }

  function getHandlers(set, handlerProps) {
    var onStart = function onStart(event) {
      if (event && "touches" in event && event.touches.length > 1) return;
      set(function (state, props) {
        if (props.trackMouse) {
          document.addEventListener(mouseMove, onMove);
          document.addEventListener(mouseUp, onUp);
        }

        var _ref = "touches" in event ? event.touches[0] : event,
            clientX = _ref.clientX,
            clientY = _ref.clientY;

        var xy = rotateXYByAngle([clientX, clientY], props.rotationAngle);
        return _extends({}, state, initialState, {
          initial: [].concat(xy),
          xy: xy,
          start: event.timeStamp || 0
        });
      });
    };

    var onMove = function onMove(event) {
      set(function (state, props) {
        if ("touches" in event && event.touches.length > 1) {
          return state;
        }

        var _ref2 = "touches" in event ? event.touches[0] : event,
            clientX = _ref2.clientX,
            clientY = _ref2.clientY;

        var _rotateXYByAngle = rotateXYByAngle([clientX, clientY], props.rotationAngle),
            x = _rotateXYByAngle[0],
            y = _rotateXYByAngle[1];

        var deltaX = x - state.xy[0];
        var deltaY = y - state.xy[1];
        var absX = Math.abs(deltaX);
        var absY = Math.abs(deltaY);
        var time = (event.timeStamp || 0) - state.start;
        var velocity = Math.sqrt(absX * absX + absY * absY) / (time || 1);
        var vxvy = [deltaX / (time || 1), deltaY / (time || 1)];
        var dir = getDirection(absX, absY, deltaX, deltaY);
        var delta = typeof props.delta === "number" ? props.delta : props.delta[dir.toLowerCase()] || defaultProps.delta;
        if (absX < delta && absY < delta && !state.swiping) return state;
        var eventData = {
          absX: absX,
          absY: absY,
          deltaX: deltaX,
          deltaY: deltaY,
          dir: dir,
          event: event,
          first: state.first,
          initial: state.initial,
          velocity: velocity,
          vxvy: vxvy
        };
        eventData.first && props.onSwipeStart && props.onSwipeStart(eventData);
        props.onSwiping && props.onSwiping(eventData);
        var cancelablePageSwipe = false;

        if (props.onSwiping || props.onSwiped || "onSwiped" + dir in props) {
          cancelablePageSwipe = true;
        }

        if (cancelablePageSwipe && props.preventDefaultTouchmoveEvent && props.trackTouch && event.cancelable) event.preventDefault();
        return _extends({}, state, {
          first: false,
          eventData: eventData,
          swiping: true
        });
      });
    };

    var onEnd = function onEnd(event) {
      set(function (state, props) {
        var eventData;

        if (state.swiping && state.eventData) {
          eventData = _extends({}, state.eventData, {
            event: event
          });
          props.onSwiped && props.onSwiped(eventData);
          var onSwipedDir = props["onSwiped" + eventData.dir];
          onSwipedDir && onSwipedDir(eventData);
        } else {
          props.onTap && props.onTap({
            event: event
          });
        }

        return _extends({}, state, initialState, {
          eventData: eventData
        });
      });
    };

    var cleanUpMouse = function cleanUpMouse() {
      document.removeEventListener(mouseMove, onMove);
      document.removeEventListener(mouseUp, onUp);
    };

    var onUp = function onUp(e) {
      cleanUpMouse();
      onEnd(e);
    };

    var attachTouch = function attachTouch(el, passive) {
      var cleanup = function cleanup() {};

      if (el && el.addEventListener) {
        var tls = [[touchStart, onStart], [touchMove, onMove], [touchEnd, onEnd]];
        tls.forEach(function (_ref3) {
          var e = _ref3[0],
              h = _ref3[1];
          return el.addEventListener(e, h, {
            passive: passive
          });
        });

        cleanup = function cleanup() {
          return tls.forEach(function (_ref4) {
            var e = _ref4[0],
                h = _ref4[1];
            return el.removeEventListener(e, h);
          });
        };
      }

      return cleanup;
    };

    var onRef = function onRef(el) {
      if (el === null) return;
      set(function (state, props) {
        if (state.el === el) return state;
        var addState = {};

        if (state.el && state.el !== el && state.cleanUpTouch) {
          state.cleanUpTouch();
          addState.cleanUpTouch = void 0;
        }

        if (props.trackTouch && el) {
          addState.cleanUpTouch = attachTouch(el, !props.preventDefaultTouchmoveEvent);
        }

        return _extends({}, state, {
          el: el
        }, addState);
      });
    };

    var output = {
      ref: onRef
    };

    if (handlerProps.trackMouse) {
      output.onMouseDown = onStart;
    }

    return [output, attachTouch];
  }

  function updateTransientState(state, props, attachTouch) {
    var addState = {};

    if (!props.trackTouch && state.cleanUpTouch) {
      state.cleanUpTouch();
      addState.cleanUpTouch = void 0;
    } else if (props.trackTouch && !state.cleanUpTouch) {
      if (state.el) {
        addState.cleanUpTouch = attachTouch(state.el, !props.preventDefaultTouchmoveEvent);
      }
    }

    return _extends({}, state, addState);
  }

  function useSwipeable(options) {
    var trackMouse = options.trackMouse;
    var transientState = React__namespace.useRef(_extends({}, initialState));
    var transientProps = React__namespace.useRef(_extends({}, defaultProps));
    transientProps.current = _extends({}, defaultProps, options, {
      delta: options.delta === void 0 ? defaultProps.delta : options.delta,
      rotationAngle: options.rotationAngle === void 0 ? defaultProps.rotationAngle : options.rotationAngle,
      trackTouch: options.trackTouch === void 0 ? defaultProps.trackTouch : options.trackTouch
    });

    var _React$useMemo = React__namespace.useMemo(function () {
      return getHandlers(function (stateSetter) {
        return transientState.current = stateSetter(transientState.current, transientProps.current);
      }, {
        trackMouse: trackMouse
      });
    }, [trackMouse]),
        handlers = _React$useMemo[0],
        attachTouch = _React$useMemo[1];

    transientState.current = updateTransientState(transientState.current, transientProps.current, attachTouch);
    return handlers;
  }

  exports.DOWN = DOWN;
  exports.LEFT = LEFT;
  exports.RIGHT = RIGHT;
  exports.UP = UP;
  exports.useSwipeable = useSwipeable;

})));
//# sourceMappingURL=react-swipeable.umd.js.map


/***/ })

}]);